import React from 'react';
import propTypes from 'prop-types';
import { Button } from "reactstrap";
import { message } from 'antd';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';

// import moment from 'moment';
import Notification from '../../../components/Alert';
import Loader from '../../../../../../Global/Loader'
import CreateContext from '../../store/CreateContext';
import { validateFrequency } from './utils';
import { Services } from '../../../../../../../repositories/clients/Services';

const Notify = ({ type, text }) => {
  if (type === 'success') {
    message.success(text);
  } else if (type === 'error') {
    message.error(text);
  } else if (type === 'warning') {
    message.warning(text);
  }
};

function SaveReport(props) {
  const context = React.useContext(CreateContext);
  const [updating, setUpdating] = React.useState(false);
  const [isRedirect, setIsRedirect] = React.useState(false);

  /*=============================================
  =            Scheme definition                =
  =============================================*/

  function createOndemandScheme(context, reportId = 0) {
    let scheme = {
      reportType: context.report_type,
      reportName: context.report_name.value,
      reportDescription: context.report_description.value,
      shareTo: context.share_to,
      module: context.module_selected,
      fields: context.selected_fields,
      filters: context.filters,
      order: context.order_fields,

      emailList: context.emailList,
      customer: props.clients,
      user: localStorage.getItem('dataUser'),
      reportId: reportId,
    };

    if (!reportId) delete scheme.reportId;

    return scheme;
  }
  function createScheduledScheme(context, reportId = 0) {
    let scheme = {
      reportType: context.report_type,
      reportName: context.report_name.value,
      reportDescription: context.report_description.value,
      shareTo: context.share_to,

      type: context.config.frequency,
      recurrence:
        context.config.frequency === 'Monthly'
          ? context.config.Monthly
          : context.config.Daily,
      startDate: context.config.startDate.value,
      endDate: context.config.endDate.value,
      hour: context.config.hour.value,
      day: Number(context.config.day),
      timeZone: context.config.timeZone,
      timeZoneValue: context.config.timeZoneValue,
      timeZoneStr: context.config.timeZoneStr,

      module: context.module_selected,
      filters: context.filters,
      order: context.order_fields,
      emailList: context.emailList,
      customer: props.clients,
      user: localStorage.getItem('dataUser'),
      fields: context.selected_fields,
      reportId: reportId,
    };

    if (!reportId) delete scheme.reportId;

    return scheme;
  }

  /*=============================================
  =            Creation Functions               =
  =============================================*/

  const CreateOnDemand = React.useCallback(async (context) => {
    try {
      setUpdating(true);
      const body = createOndemandScheme(context);
      // const respCreate =
      await axios.post(
        `${Services.REPORTS.path}reports/builder/create/ondemand`,
        body
      );
      setUpdating(false);
      Notification(props.t("success_created"), props.t("report_success_created"), 'success');

      context.model_reset();

      setTimeout(() => {
      }, 3000);

      setIsRedirect(true);
    } catch (error) {
      setUpdating(false);
      Notification('Error', props.t("error_create_report"), 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CreateScheduled = React.useCallback(async (context) => {
    try {
      setUpdating(true);
      const body = createScheduledScheme(context);
      // const respScheduled =
      await axios.post(
        `${Services.REPORTS.path}reports/builder/create/scheduled`,
        body
      );

      setUpdating(false);
      Notification(props.t("success_created"), props.t("report_success_created"), 'success');

      context.model_reset();

      setTimeout(() => {
      }, 3000);

      setIsRedirect(true);
    } catch (error) {
      setUpdating(false);
      Notification('Error', props.t("error_create_report"), 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*=============================================
  =            Update Functions            =
  =============================================*/

  const UpdateOnDemand = React.useCallback(
    async (context, reportId, onEvent) => {
      try {
        setUpdating(true);
        const body = createOndemandScheme(context, reportId);
        // const resUpdate =
        await axios.put(
          `${Services.REPORTS.path}reports/builder/update/ondemand`,
          body
        );

        setUpdating(false);
        Notification(
          props.t("report_updated"),
          props.t("configuration_successfull"),
          'success'
        );
        setTimeout(() => {
          onEvent();
        }, 1000);
      } catch (error) {
        setUpdating(false);
        Notification(
          'Error',
          'Ocurrió un error al intentar actualizar reporte',
          'error'
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const UpdateScheduled = React.useCallback(
    async (context, reportId, onEvent) => {
      try {
        setUpdating(true);
        const body = createScheduledScheme(context, reportId);
        // const resUpdate =
        await axios.put(
          `${Services.REPORTS.path}reports/builder/update/scheduled`,
          body
        );
        setUpdating(false);
        Notification(
          props.t("report_updated"),
          props.t("configuration_successfull"),
          'success'
        );
        setTimeout(() => {
          onEvent();
        }, 1000);
      } catch (error) {
        // console.error('UpdateScheduled -- ', error);
        setUpdating(false);
        Notification(
          'Error',
          props.t("error_update_report"),
          'error'
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleSaveReport(type) {
    let valid = true;

    if (!context.report_name.value) {
      Notify({ type: 'error', text: props.t("you_must_name") });
      valid = false;
    } else if (!context.report_description.value) {
      Notify({ type: 'error', text: 'Descripción requerida' });
      valid = false;
    }

    if (context.report_type === 'ondemand') {
      if (!context.selected_fields.length) {
        Notify({
          type: 'error',
          text: props.t("you_must_select_field"),
        });
        valid = false;
      }
      if (valid) {
        if (type === 'create') {
          CreateOnDemand(context);
        } else {
          UpdateOnDemand(context, props.reportId, props.onEvent);
          // props.onEvent();
        }
      }
    } else if (context.report_type === 'scheduled') {
      if (context.config.frequency === 'Daily') {
        if (!validateFrequency(context.config.Daily)) {
          Notify({
            type: 'error',
            text: props.t("you_must_frequency_days"),
          });
          valid = false;
        }
        if (!context.config.hour.value) {
          Notify({
            type: 'error',
            text: props.t("hour_not_valid"),
          });
          valid = false;
        }
        // if (!context.emailList.length) {
        //   Notify({
        //     type: 'error',
        //     text: props.t("no_mail_list"),
        //   });
        //   valid = false;
        // }
        if (!context.selected_fields.length) {
          Notify({
            type: 'error',
            text: props.t("you_must_select_field"),
          });
          valid = false;
        }
      } else if (context.config.frequency === 'Monthly') {
        if (!validateFrequency(context.config.Monthly)) {
          Notify({
            type: 'error',
            text: props.t("month_recurrency_not_selected"),
          });
          valid = false;
        }
        if (!context.config.hour.value) {
          Notify({
            type: 'error',
            text: props.t("valid_time_not_selected"),
          });
          valid = false;
        }
        // if (!context.emailList.length) {
        //   Notify({
        //     type: 'error',
        //     text: props.t("mailing_list_not_provided"),
        //   });
        //   valid = false;
        // }
        if (!context.config.day) {
          Notify({
            type: 'error',
            text: props.t("month_not_selected"),
          });
          valid = false;
        }
        if (!context.selected_fields.length) {
          Notify({
            type: 'error',
            text: props.t("you_must_select_field"),
          });
          valid = false;
        }
      } else {
        Notify({ type: 'error', text: props.t("frecuency_not_selected") });
        valid = false;
      }

      if (valid) {
        if (type === 'create') {
          CreateScheduled(context);
        } else {
          UpdateScheduled(context, props.reportId, props.onEvent);
          // props.onEvent();
        }
      }
    }
  }

  return (
    <div className="col-md-6 d-flex  justify-content-sm-end justify-content-xs-start justify-content-end col-md-6 col-sm-12 col-xs-12 col-lg-6 col-xl-6">
      {isRedirect ? <Redirect to={'/reports'} /> : ''}
      <div>
        {props.action === 'create' ? (
          <div className='col-12 row'>
            <div className='col-xs-6'>
              <Button
                color="primary"
                style={{ marginRight: "10px" }}
                onClick={() => handleSaveReport('create')}
              >
                {props.t("save")}
              </Button>
            </div>
            <div className='col-xs-6'>
              <Button color='secondary' onClick={() => props.history.push('/reports')}>
                {props.t("cancel")}
              </Button>
            </div>
          </div>
        ) : (
          <Button
            color="primary"
            onClick={() => handleSaveReport('edit')}
          >
            {props.t("save")}
          </Button>
        )}
      </div>
      <Loader hidden={!updating}></Loader>
    </div>
  );
}

SaveReport.propTypes = {
  onEvent: propTypes.func,
};
SaveReport.defaultProps = {
  onEvent: () => { },
};

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(SaveReport)));
